import { handleActions } from 'redux-actions';
import { m } from '../utils';

const initialState = {
  week: [],
};

const CHANGE_WEEK = 'CHANGE_WEEK';

/** ******************* ACTIONS ******************** */

const changeWeek = week => ({
  type: [CHANGE_WEEK],
  week,
});

export const getDaysInWeek = day => dispatch => {
  // "isoWeek" starts on Mondays, to start from Sunday, change to "week"
  const beginningOfWeek = day.startOf('isoWeek');
  const daysArray = Array.from(Array(7)).map((x, i) =>
    m(beginningOfWeek)
      .add(i, 'days')
      .format()
  );
  dispatch(changeWeek(daysArray));
};

/** ******************* REDUCER ******************** */

export default handleActions(
  {
    [CHANGE_WEEK]: (state, { week }) => ({
      ...state,
      week,
    }),
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/redux/calendar.js